let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("49h4g")).then(() => parcelRequire('aDDNz'));